import Axios, { AxiosRequestConfig, Method } from 'axios';

import { BASE_URL } from '../api/Urls';
import { getValidToken } from '../auth/Auth';

Axios.interceptors.response.use(undefined, error => {
	console.log('INTERCEPTOR ERROR:', error);
	return Promise.reject(error);
});

const request = ({
	url,
	data,
	method,
	body,
	headers,
}: {
	url?: string;
	data?: string;
	method?: Method;
	body?: string;
	headers?: unknown;
}) =>
	new Promise(async (resolve, reject) => {
		const token = await getValidToken();
		const config: AxiosRequestConfig = {
			method: method || 'post',
			url: url || '',
			params: data,
			data: body,
			headers: headers || {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				Authorization: token,
			},
			responseType: 'json',
		};

		Axios(config)
			.then(res => {
				console.log(
					`%c SUCCESS: ${config?.url?.replace(BASE_URL, '')}`,
					'color: #0ffaac',
					res
				);
				resolve(res.data);
			})
			.catch(err => {
				console.log(
					`%c FAILED: ${config?.url?.replace(BASE_URL, '')}`,
					'color: #FF0000',
					err.response
				);
				reject(err.response);
			});
	});

export default { request };
